import { render, staticRenderFns } from "./authSuccessOpen.vue?vue&type=template&id=0ad5462e&scoped=true&"
import script from "./authSuccessOpen.vue?vue&type=script&lang=js&"
export * from "./authSuccessOpen.vue?vue&type=script&lang=js&"
import style0 from "./authSuccessOpen.vue?vue&type=style&index=0&id=0ad5462e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5462e",
  null
  
)

export default component.exports